import { mode } from '@chakra-ui/theme-tools';
export const inputStyles = {
	components: {
		Input: {
			defaultProps: {
				variant: 'main',
			},
			baseStyle: {
				field: {
					fontWeight: 400,
					borderRadius: '10px'
				}
			},

			variants: {
				main: (props: any) => ({
					field: {
						bg: mode('gray.50', 'whiteAlpha.50')(props),
						border: '1px solid',
						color: mode('secondaryGray.900', 'white')(props),
						borderColor: mode('secondaryGray.100', 'whiteAlpha.100')(props),
						borderRadius: '12px',
						fontSize: 'sm',
						p: '20px',
						transition: 'border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease',
						_placeholder: { color: 'secondaryGray.600' },
						_focus: {
							bg: mode('white', 'whiteAlpha.100')(props),
							borderColor: mode('brand.500', 'brand.400')(props),
							boxShadow: mode(
								'0 0 0 3px rgba(2, 63, 127, 0.1)',
								'0 0 0 3px rgba(53, 120, 191, 0.2)'
							)(props),
						},
					}
				}),
				auth: (props: any) => ({
					field: {
						fontWeight: '500',
						color: mode('navy.700', 'white')(props),
						bg: mode('transparent', 'transparent')(props),
						border: '1px solid',
						borderColor: mode('secondaryGray.100', 'rgba(135, 140, 189, 0.3)')(props),
						borderRadius: '12px',
						transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
						_placeholder: { color: 'secondaryGray.600', fontWeight: '400' },
						_focus: {
							borderColor: mode('brand.500', 'brand.400')(props),
							boxShadow: mode(
								'0 0 0 2px rgba(66, 42, 251, 0.15)',
								'0 0 0 2px rgba(117, 81, 255, 0.25)'
							)(props),
						},
					}
				}),
				authSecondary: () => ({
					field: {
						bg: 'transparent',
						border: '1px solid',
						borderColor: 'secondaryGray.100',
						borderRadius: '12px',
						_placeholder: { color: 'secondaryGray.600' }
					}
				}),
				search: () => ({
					field: {
						border: 'none',
						py: '11px',
						borderRadius: 'inherit',
						_placeholder: { color: 'secondaryGray.600' }
					}
				})
			}
		},
		NumberInput: {
			defaultProps: {
				variant: 'main',
			},
			baseStyle: {
				field: {
					fontWeight: 400
				}
			},

			variants: {
				main: (props: any) => ({
					field: {
						bg: mode('gray.50', 'whiteAlpha.50')(props),
						border: '1px solid',
						borderColor: mode('secondaryGray.100', 'whiteAlpha.100')(props),
						borderRadius: '12px',
						transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
						_placeholder: { color: 'secondaryGray.600' },
						_focus: {
							bg: mode('white', 'whiteAlpha.100')(props),
							borderColor: mode('brand.500', 'brand.400')(props),
							boxShadow: mode(
								'0 0 0 2px rgba(2, 63, 127, 0.15)',
								'0 0 0 2px rgba(53, 120, 191, 0.25)'
							)(props),
						},
					}
				}),
				auth: () => ({
					field: {
						bg: 'transparent',
						border: '1px solid',

						borderColor: 'secondaryGray.100',
						borderRadius: '12px',
						_placeholder: { color: 'secondaryGray.600' }
					}
				}),
				authSecondary: () => ({
					field: {
						bg: 'transparent',
						border: '1px solid',

						borderColor: 'secondaryGray.100',
						borderRadius: '12px',
						_placeholder: { color: 'secondaryGray.600' }
					}
				}),
				search: () => ({
					field: {
						border: 'none',
						py: '11px',
						borderRadius: 'inherit',
						_placeholder: { color: 'secondaryGray.600' }
					}
				})
			}
		},
		Select: {
			defaultProps: {
				variant: 'main',
			},
			baseStyle: {
				field: {
					fontWeight: 400
				}
			},

			variants: {
				main: (props: any) => ({
					field: {
						bg: mode('gray.50', 'whiteAlpha.50')(props),
						border: '1px solid',
						color: mode('secondaryGray.900', 'white')(props),
						borderColor: mode('secondaryGray.100', 'whiteAlpha.100')(props),
						borderRadius: '12px',
						transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease',
						_placeholder: { color: 'secondaryGray.600' },
						_focus: {
							bg: mode('white', 'whiteAlpha.100')(props),
							borderColor: mode('brand.500', 'brand.400')(props),
							boxShadow: mode(
								'0 0 0 2px rgba(2, 63, 127, 0.15)',
								'0 0 0 2px rgba(53, 120, 191, 0.25)'
							)(props),
						},
					},
					icon: {
						color: 'secondaryGray.600'
					}
				}),
				mini: (props: any) => ({
					field: {
						bg: mode('transparent', 'navy.800')(props),
						border: '0px solid transparent',
						fontSize: '0px',
						p: '10px',
						_placeholder: { color: 'secondaryGray.600' }
					},
					icon: {
						color: 'secondaryGray.600'
					}
				}),
				subtle: () => ({
					box: {
						width: 'unset'
					},
					field: {
						bg: 'transparent',
						border: '0px solid',
						color: 'secondaryGray.600',
						borderColor: 'transparent',
						width: 'max-content',
						_placeholder: { color: 'secondaryGray.600' }
					},
					icon: {
						color: 'secondaryGray.600'
					}
				}),
				transparent: (props: any) => ({
					field: {
						bg: 'transparent',
						border: '0px solid',
						width: 'min-content',
						color: mode('secondaryGray.600', 'secondaryGray.600')(props),
						borderColor: 'transparent',
						padding: '0px',
						paddingLeft: '8px',
						paddingRight: '20px',
						fontWeight: '700',
						fontSize: '14px',
						_placeholder: { color: 'secondaryGray.600' }
					},
					icon: {
						transform: 'none !important',
						position: 'unset !important',
						width: 'unset',
						color: 'secondaryGray.600',
						right: '0px'
					}
				}),
				auth: () => ({
					field: {
						bg: 'transparent',
						border: '1px solid',

						borderColor: 'secondaryGray.100',
						borderRadius: '12px',
						_placeholder: { color: 'secondaryGray.600' }
					}
				}),
				authSecondary: (props: any) => ({
					field: {
						bg: 'transparent',
						border: '1px solid',

						borderColor: 'secondaryGray.100',
						borderRadius: '12px',
						_placeholder: { color: 'secondaryGray.600' }
					}
				}),
				search: (props: any) => ({
					field: {
						border: 'none',
						py: '11px',
						borderRadius: 'inherit',
						_placeholder: { color: 'secondaryGray.600' }
					}
				})
			}
		}
	}
};
